"use strict";

import angular from "angular";

const name = "formatPorcentagem";
const factory = function formatPorcentagemFilter() {
    return function (input) {
        return input ? input.toString().replace(".", ",") : "0";
    };
};
angular.module("nucont.shared").filter(name, factory);
export default { name, factory };
